// extracted by mini-css-extract-plugin
export default {"header":"ProductOptionInventoryForm_header__arW90"};